// AboutUs.jsx
import React, { useState, useEffect } from 'react';
import './AboutUs.css';
import Sidebar from '../components/Sidebar';

const AboutUs = () => {
  const [darkMode, setDarkMode] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
    if (!sidebarOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  };

  const handleOverlayClick = () => {
    setSidebarOpen(false);
    document.body.style.overflow = 'auto';
  };

  useEffect(() => {
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  const stats = [

  ];

  const features = [
    {
      icon: '🏆',
      title: '',
      description: ''
    },
    {
      icon: '📊',
      title: '',
      description: ''
    },
    {
      icon: '🎮',
      title: '',
      description: ''
    },
    {
      icon: '⚖️',
      title: '',
      description: ''
    }
  ];

  const leagueStructure = [
  ];

  const coreValues = [

  ];

  return (
    <div className={`app-layout ${!darkMode ? 'light-mode' : ''}`}>
      <button className="burger-menu" onClick={toggleSidebar}>
        <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none">
          <path d="M3 12h18M3 6h18M3 18h18"></path>
        </svg>
      </button>

      {sidebarOpen && (
        <div className="sidebar-overlay visible" onClick={handleOverlayClick}></div>
      )}

      <div className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <button className="sidebar-close" onClick={toggleSidebar} aria-label="Close sidebar">
          <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none">
            <path d="M18 6L6 18M6 6l12 12"></path>
          </svg>
        </button>
        <div className="sidebar-content-wrapper">
          <Sidebar darkMode={darkMode} setDarkMode={setDarkMode} />
        </div>
      </div>

      <div className={`aboutus-container ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <div className="page-header">
          <h1 className="page-title">ჩვენს შესახებ</h1>
          <p className="page-subtitle">ბოდიშს გიხდით ინფორმაცია ამ გვერდზე არ არის ხელმისაწვდომი, ჩვენი გუნდი მუშაობს და მალე განახლდება.</p>
        </div>

        <div className="card">
          <h2 className="card-title orange"></h2>
          <div className="card-content">
            <p>

            </p>
          </div>
        </div>

        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className={`stat-number ${stat.color}`}>
                {stat.number}
              </div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="card">
          <h2 className="card-title blue"></h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-item">
                <div className="feature-icon">{feature.icon}</div>
                <div className="feature-content">
                  <h3>{feature.title}</h3>
                  <p>{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="two-column">
          <div className="card">
            <h2 className="card-title green"></h2>
            <div className="info-table">
              {/* {leagueStructure.map((item, index) => (
                <div key={index} className="info-row">
                  <span className="info-label">{item.label}</span>
                  <span className={`info-value ${item.highlight ? 'highlight' : ''}`}>
                    {item.value}
                  </span>
                </div>
              ))} */}
            </div>
          </div>

          <div className="card">
            <h2 className="card-title purple"></h2>
            <ul className="values-list">
              {/* {coreValues.map((value, index) => (
                <li key={index} className="value-item">
                  <div className="value-bullet"></div>
                  <span className="value-text">{value}</span>
                </li>
              ))} */}
            </ul>
            <div className="values-note">
              <p>
                
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
